module.exports = {"id":"225145","name":"Ramahlwe Mphahlele","rating":"71","photo":"./data/images/photos/0/225145.png","club":{"name":"Kaizer Chiefs","logo":"./data/images/clubs/KaizerChiefs.png"},"positions":["DD","DC","DLD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RamahlweMphahlele0.json
// module id = 3527
// module chunks = 0